import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

export interface SeedDemoEvento {
  id: number;
  nombre: string;
  actual: boolean;
  fecha_inicio: string;
  fecha_fin: string;
}

export interface SeedDemoStatus {
  tieneEventos: boolean;
  eventos: SeedDemoEvento[];
}

export async function getSeedDemoStatusService(): Promise<SeedDemoStatus> {
  const response = await axios.get(`${API_URL}seedDemo/status`);
  return response.data.doc.data;
}
